<template>
  <q-timeline
    layout="loose"
    color="secondary"
  >
    <q-timeline-entry
      v-for="item in timeline"
      :key="item.title"
      :title="item.title"
      :subtitle="item.formattedTime"
      :icon="item.icon"
      :color="item.color"
      :side="item.side || 'right'"
    >
      <template
        #subtitle
      >
        <formatted-date
          v-if="item.time"
          class="q-mt-xs"
          style="line-height: 25px;"
          :value="item.time"
          format="long"
          component="div"
        />
        <span
          v-else
          class="q-mt-sm"
        >
          {{ item.formattedTime }}
        </span>
      </template>
      <div v-if="item.description">
        {{ item.description }}
      </div>
    </q-timeline-entry>
  </q-timeline>
</template>

<script>
import FormattedDate from 'src/modules/admin/components/FormattedDate'

export default {
  name: 'OrderItemTimeline',
  components: {
    FormattedDate
  },
  props: {
    orderItem: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      layout: 'dense',
      side: 'right'
    }
  },
  configuration: ['currentCircuit'],
  computed: {
    timeline () {
      let timeline = [
        {
          title: 'Created',
          time: this.orderItem.createdAt,
          color: 'primary',
          icon: 'create'
        },
        {
          title: 'Placed',
          time: this.orderItem.placedAt,
          color: 'primary',
          icon: 'shopping_cart'
        },
        {
          title: 'Paid',
          time: this.orderItem.paidAt,
          color: 'positive',
          icon: 'payment'
        },
        {
          title: 'Effective',
          time: this.orderItem.effectiveAt,
          color: 'info',
          icon: 'event'
        },
        {
          title: 'Voided',
          time: this.orderItem.voidedAt,
          color: 'negative',
          icon: 'delete'
        },
        {
          title: 'Due Time',
          time: this.orderItem.dueTime,
          color: 'info',
          icon: 'save_alt'
        },
        {
          title: 'Pick Prep Printed',
          time: this.orderItem.pickPrepPrintedAt,
          color: 'info',
          icon: 'print'
        },
        {
          title: 'Collected',
          time: this.orderItem.collectedAt,
          color: 'success',
          icon: 'check_circle'
        },
        {
          title: 'Prepared',
          time: this.orderItem.preparedAt,
          color: 'info',
          icon: 'kitchen'
        },
        {
          title: 'Delivered',
          time: this.orderItem.deliveredAt,
          color: 'success',
          icon: 'local_shipping'
        }
      ]

      // Filter out entries with null times
      timeline = _.filter(timeline, item => !!item.time)

      // Sort by time
      timeline = _.sortBy(timeline, 'time')

      // Add format time
      _.each(timeline, timelineEntry => {
        timelineEntry.formattedTime = this.$d(timelineEntry.time, 'long')
      })

      // Add durations
      let previousTime
      timeline = _.reduce(timeline, (result, timelineEntry, _index) => {
        if (previousTime) {
          const elasedSeconds = (timelineEntry.time.getTime() - previousTime.getTime()) / 1000

          if (elasedSeconds > 1) {
            const duration = timelineEntry.time.relativeTime({ relativeTo: previousTime, duration: true })
            result.push({
              formattedTime: duration,
              color: 'info',
              icon: 'timer',
              side: 'right'
            })
          }
        }
        result.push(timelineEntry)
        previousTime = timelineEntry.time
        return result
      }, [])

      return timeline
    }
  }
}

</script>

<style lang="scss" scoped>
.future {
  border: dashed 1px;
  opacity: 0.6;
}

.list-complete-item {
  transition: all 0.5s;
  display: inline-block;
}
.list-complete-enter {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-active {
  position: absolute;
}

</style>
